import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Hero1 from "../components/Hero1";
import BlogSlider from "../components/blog/slider";
import Populares from "../components/blog/Populares";
import ArticleCard from "../components/blog/ArticleCard";
import { blogCategories, blogArticles } from "../data/blogContent";

const BlogDetails = () => {
  const { id } = useParams();
  const category = blogCategories[id];

  const articles = useMemo(
    () =>
      blogArticles
        .filter((article) => article.category === id)
        .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)),
    [id]
  );

  if (!category) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 bg-[#f7fafc] px-6 text-center">
        <h1 className="text-3xl font-bold text-[#123070]">
          Tema no encontrado
        </h1>
        <p className="text-gray-600 max-w-md">
          La categoría que estás buscando no existe o fue actualizada. Vuelve al
          blog para explorar artículos disponibles.
        </p>
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 px-5 py-3 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition-colors duration-150"
        >
          Volver al blog
        </Link>
      </div>
    );
  }

  const highlightArticle = articles[0];

  return (
    <>
      <Hero1
        imagen={category.heroImage}
        titulo={category.title}
        descripcion={category.subtitle}
      />
      <div className="bg-[#f4f9fb] py-14">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <nav className="text-sm text-gray-500 flex items-center gap-2">
            <Link to="/blog" className="hover:text-blue-700 font-medium">
              Blog
            </Link>
            <span>/</span>
            <span className="text-blue-700 font-semibold">
              {category.title}
            </span>
          </nav>
          <div className="mt-10 grid gap-8 sm:grid-cols-2 xl:grid-cols-3">
            {articles.length === 0 ? (
              <div className="sm:col-span-2 xl:col-span-3 bg-white rounded-3xl border border-blue-100 p-10 text-center shadow-sm">
                <h2 className="text-2xl font-semibold text-[#123070] mb-4">
                  Pronto encontrarás contenido aquí
                </h2>
                <p className="text-gray-600">
                  Estamos preparando artículos inspiradores para esta categoría.
                  Mientras tanto, visita otras secciones del blog.
                </p>
              </div>
            ) : (
              articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))
            )}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Populares highlight={highlightArticle} />
      </div>
      <BlogSlider items={articles.slice(0, 5)} />
    </>
  );
};

export default BlogDetails;
